import React from "react";
import { Routes, Route } from "react-router-dom";
import LandingPage from "../components/UI/LandingPage/LandingPage";
import WebXRExperience from "../components/experience/WebXRExperience";
import OriginalExperiencePage from "../components/experience/OriginalExperiencePage";
import GrooveJonesIntro from "../components/UI/GrooveJonesIntro";

const RouteHandler = () => {
  return (
    <Routes>
      <Route path="/" element={<GrooveJonesIntro key="crown-intro"><LandingPage autoplaySequence /></GrooveJonesIntro>} />
      <Route path="/main" element={<OriginalExperiencePage />} />
      <Route path="/legacy" element={<GrooveJonesIntro key="legacy-intro"><LandingPage autoplaySequence /></GrooveJonesIntro>} />
      <Route path="/legacy/main" element={<OriginalExperiencePage />} />
      <Route path="/prototype" element={<GrooveJonesIntro key="prototype-intro"><WebXRExperience /></GrooveJonesIntro>} />
    </Routes>
  );
};
export default RouteHandler;
